import { WithTranslation, withTranslation } from "react-i18next";
import React from "react";
import { useRouter } from "next/router";
import { MainHead } from "../../../head/MainHead";

export interface IProps {
  hotelName?: string;
  origin?: string;
  noindex?: boolean;
  t?: any;
}

function HotelHeadComponent(props: IProps & WithTranslation) {
  const { hotelName, t, ...rest } = props;
  const router = useRouter();
  const pathname = router.pathname;

  let title;
  let description;
  if (pathname === "/hotels/[hotelId]" && hotelName) {
    title = t("seo.titleHotelShow", { name: hotelName });
    description = t("seo.descriptionHotelShow", { name: hotelName });
  } else {
    title = t("seo.titleHotelIndex");
    description = t("seo.descriptionHotelIndex");
  }

  return <MainHead title={title} description={description} {...rest} />;
}
export const HotelHead: any = withTranslation(["constant"])(HotelHeadComponent);
